import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../context/userContext';

const ProtectedRoute = ({ requireAuth = true, requirePremium = false }) => {
  const { user } = useUser();
  
  // Check if user needs to be authenticated to access page
  if (requireAuth && !user) {
    // Redirect to login page
    return <Navigate to="/login" replace />;
  }

  // Check if user needs premium plan to access page
  if (requirePremium && (!user || user.data.planType !== 'Premium')) {
    // Redirect to subscription page
    return <Navigate to="/settings" replace />;
  }

  // If all checks pass, render the child routes
  return <Outlet />;
};

export default ProtectedRoute;